import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";

function FieldsList(props) {
  function renderField(field, fieldIndex) {
    return (
      <div className="col-6" key={field}>
        <button
          className="btn"
          onClick={(e) => {
            e.stopPropagation();
            toggleField(field);
          }}
        >
          {activeFields.includes(field) ? (
            <i className="fa fa-check align-middle mr-1  text-primary"></i>
          ) : null}
          {field}
        </button>
      </div>
    );
  }

  function toggleField(field) {
    let fieldIndex = activeFields.indexOf(field);
    if (fieldIndex >= 0) {
      activeFields.splice(fieldIndex, 1);
    } else {
      activeFields.push(field);
    }
    changeActiveFieldsState(JSON.stringify(activeFields));
  }

  let fields = props.fields || [];

  let [activeFieldsJSON, changeActiveFieldsState] = useState(
    JSON.stringify(props.activeFields || [])
  );

  let activeFields = JSON.parse(activeFieldsJSON);

  if (!props.fields) return null;

  return (
    <Dropdown
      alignRight
      className="d-inline-block align-middle mr-2"
      onToggle={(isOpen) => {
        if (!isOpen) props.changeFn(activeFields);
      }}
    >
      <Dropdown.Toggle variant="light">
        <i className="text-muted fa fa-cog p-0"></i>
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu-lg">
        <div className="row">
          {fields.map((field, fieldIndex) => renderField(field, fieldIndex))}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}
export default FieldsList;
